import type {IAsset} from '@netx/core-asset-next/schema';
import {canManageAssetViews} from './canManageAssetViews';

export const canEditAssetViews = (
    asset?: Pick<IAsset, 'permissionMatrix' | 'permissions'>,
): boolean => {
    return canManageAssetViews(asset);
};
